export default __webpack_public_path__ + "static/media/p5-6.217f8903.png";